import { Component, Input, OnInit } from '@angular/core';
import { get, join } from 'lodash';
import { IWizardContentComponent } from '../../../wizard.content';
import { ApplicationWizardService } from '../../../services/application/application.wizard.service';
import { CommonRegEx } from '@nrwl/common-lib';

export const APP_TYPE_KEY = 'application-type';
export enum ApplicationType {
  CLOUD_BASED = 'cloud-based',
  ON_PREMISE = 'hybrid'
}

@Component({
  selector: 'app-review-html',
  templateUrl: './review.html',
  providers: [],
  styleUrls: ['../new.application.style.scss', './review.style.scss']
})
export class ReviewHtmlComponent implements IWizardContentComponent, OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() previousOutput: any;
  appType: ApplicationType;
  loadingMsg: string;

  constructor(private wizardService: ApplicationWizardService) {}

  ngOnInit() {
    this.appType = get(this.previousOutput, APP_TYPE_KEY, ApplicationType.CLOUD_BASED);
    this.generateTextByMode(this.wizardService.editMode);

    // ATW-1833 - If user forgets to add protocol to the url, add a default one for them:
    const re = new RegExp(CommonRegEx.URL_START_REGEX, 'i');
    if (this.step.parent.output.url && !re.test(this.step.parent.output.url)) {
      this.step.parent.output.url = 'http://' + this.step.parent.output.url;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  generateTextByMode(editMode): void {
    if (!editMode) {
      this.loadingMsg = 'Creating ' + this.step.parent.output.name + ' application';
    } else {
      this.loadingMsg = 'Updating ' + this.step.parent.output.name + ' application';
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  isCloudBased() {
    return this.appType === ApplicationType.CLOUD_BASED;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  isOnPremise() {
    return this.appType === ApplicationType.ON_PREMISE;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  renderAsOneLine(values) {
    return join(values, ', ');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  renderPortsAsOneLine(values) {
    if (!values || !Array.isArray(values)) {
      return values;
    }
    const result = [];
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      if (value.portValueType === 'single') {
        result.push(value.fixed);
      } else {
        result.push(`${value.first}-${value.last}`);
      }
    }
    return join(result, ', ');
  }
}
